import { render, staticRenderFns } from "./ActProj.vue?vue&type=template&id=10f6fdc7&scoped=true&"
import script from "./ActProj.vue?vue&type=script&lang=js&"
export * from "./ActProj.vue?vue&type=script&lang=js&"
import style0 from "./ActProj.vue?vue&type=style&index=0&id=10f6fdc7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6fdc7",
  null
  
)

export default component.exports